module.exports = __webpack_public_path__ + "img/cover_photo.73b218cf.jpg";